module.exports = __webpack_public_path__ + "img/bikehall.e739b685.png";